import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../currentAssetLedgerSlice";
import { fetchCurrentAssetLedger } from "../currentAssetLedgerThunk";
import { fetchCurrentAssetAccs } from "../../../../store/commonThunks/lookups";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const CurrentAssetLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.currentAssetLedger);
  const { curAssAccs = [], loading } = useSelector((state) => state.lookups);

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    // fetch accounts of type current_assets
    dispatch(fetchCurrentAssetAccs());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }
    dispatch(fetchCurrentAssetLedger(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"                
      >
        <Col xs={24} sm={12} md={12} lg={8} xl={6}>
          <label>Account</label>
          <SearchListAutoComplete
            optionsList={(curAssAccs || []).map((acc) => ({
              sale_id: acc.acc_id,
              display_text: acc.acc_name,
            }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Current Asset Account"
            loading={loading.curAssAccs}
            showAddNew={false}
          />
        </Col>

        {/* <RecordDateFilter
          filters={filters}
          handleFilterChange={handleFilterChange}
        /> */}

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col xs={24} sm={12} md={12} lg={8} xl={6}
          style={{ display: "flex", alignItems: "flex-end", height: 54 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }     

  `}</style>
    </Card>
  );
};

export default CurrentAssetLedgerFilters;
